<template>
  <div class="main">
    <Header
      :show="true"
      title="编辑过磅记录"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div class="content">
      <van-form
        ref="owdrForm"
        validate-first
        @submit="submit"
      >
        <van-field
          v-model="form.data.plateNumber"
          name="plateNumber"
          label="车牌号"
          placeholder="请输入"
          required
          :rules="[{ required: true, message: '请输入车牌号' }]"
        />
        <van-field
          name="materialType"
          label="物料类型"
          placeholder="请选择物料类型"
          :value="form.data.materialType"
          readonly
          clickable
          required
          :rules="[{ required: true, message: '请选择物料类型' }]"
          @click="form.showMaterialTypePicker = true"
        />
        <van-popup
          v-model="form.showMaterialTypePicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="form.materialTypeList"
            @confirm="handleConfirmMaterialType"
            @cancel="form.showMaterialTypePicker = false"
          />
        </van-popup>
        <van-field
          name="materialName"
          label="物料名称"
          placeholder="请选择物料"
          :value="form.data.materialName"
          readonly
          clickable
          required
          :rules="[{ required: true, message: '请选择物料' }]"
          @click="form.showMaterialPicker = true"
        />
        <van-popup
          v-model="form.showMaterialPicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="materialItemList()"
            @confirm="handleConfirmMaterial"
            @cancel="form.showMaterialPicker = false"
          />
        </van-popup>
        <div class="supplier-edit-wrap">
          <van-field
            v-model="form.data.supplier"
            name="supplier"
            label="供应商"
            placeholder="请输入"
            required
            :rules="[{ required: true, message: '请输入供应商' }]"
            @focus="supplierActivity = true"
            @blur="handleBlurSupplier"
          />
          <div
            v-show="supplierActivity && !!form.data.supplier"
            class="supplier-autocomplete"
          >
            <van-cell-group>
              <van-cell
                v-for="item in suggestSupplier"
                :key="item.id"
                is-link
                :title="item.name"
                @click="form.data.supplier = item.name"
              />
            </van-cell-group>
          </div>
        </div>
        <van-field
          name="tareWeight"
          label="皮重"
          required
          center
        >
          <template #input>
            <van-stepper
              v-model="form.data.tareWeight"
              step="0.5"
              min="0"
              max="1000000"
              :decimal-length="2"
              input-width="80px"
              button-size="28px"
            />
          </template>
          <template #button>
            吨
          </template>
        </van-field>
        <van-field
          name="grossWeight"
          label="毛重"
          required
          center
        >
          <template #input>
            <van-stepper
              v-model="form.data.grossWeight"
              step="0.5"
              min="0"
              max="1000000"
              :decimal-length="2"
              input-width="80px"
              button-size="28px"
            />
          </template>
          <template #button>
            吨
          </template>
        </van-field>
        <div
          v-if="checkPermission([492])"
          style="margin: 0.6rem 1rem"
        >
          <van-button
            round
            block
            type="info"
            native-type="submit"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>
<script>
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import { Dialog } from "vant";
import { pick } from "lodash";

import { edit } from "@/api/weigh";
import { getList } from "@/api/material";
import { getList as getVehicleList } from "@/api/vehicleManager";
import { getList as getSupplierList } from "@/api/supplier";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      query: {},
      materialList: [],
      supplierList: [],
      supplierActivity: false,
      form: {
        data: {
          supplier: "",
          grossWeight: 0,
          waterPercent: 0,
          vehicleType: "",
          materialType: "",
          busStatus: "1",
          quality: 5,
        },
        showVehiclePicker: false,
        vehicleTypeList: ["商砼货车", "罐装货车", "骨料货车"],
        showMaterialTypePicker: false,
        materialTypeList: ["商砼", "骨料", "粉料", "其他"],
        showMaterialPicker: false,
      },
    };
  },
  computed: {
    suggestSupplier() {
      return this.supplierList.filter((item) => {
        return item.name?.includes(this.form.data.supplier);
      });
    },
  },
  created() {
    const row = this.$route.query;
    this.query = row;
    this.form.data = {
      ...row,
      id: row.serial,
      quality: +row.quality,
      qcPhotoList: row.qcPhotoUrl ? [{ url: row.qcPhotoUrl }] : [],
      busStatus: "1",
    };

    this.getMaterialList();
    this.getSupplierList();
  },
  methods: {
    checkPermission,
    getMaterialList() {
      getList({ page: 1, limit: 1000 }).then(({ data: { data } }) => {
        const { items = [] } = data;
        this.materialList = items;
      });
    },
    getSupplierList() {
      getSupplierList({ page: 1, limit: 10000 }).then(({ data: { data } }) => {
        const { items = [] } = data;
        this.supplierList = items;
      });
    },
    handleBlurSupplier() {
      setTimeout(() => {
        this.supplierActivity = false;
      }, 10);
    },
    materialItemList() {
      const { materialList } = this;
      if (this.form.data.materialType === "商砼") {
        return materialList
          .filter((material) => {
            return (
              material.name?.includes("水泥") ||
              material.name?.includes("混凝土")
            );
          })
          .map((material) => material.name);
      } else if (this.form.data.materialType === "骨料") {
        return materialList
          .filter((material) => material.type == 1)
          .map((material) => material.name);
      } else if (this.form.data.materialType === "粉料") {
        return materialList
          .filter((material) => material.type == 2)
          .map((material) => material.name);
      } else if (this.form.data.materialType === "其他") {
        return materialList
          .filter((material) => material.type == 3)
          .map((material) => material.name);
      }
      return [];
    },
    handleClickLeft() {
      this.$router.go(-1);
    },
    qcPhotoValid(value) {
      return new Promise((resolve) => {
        if (Array.isArray(value) && value.length) {
          resolve(true);
        }
        resolve(false);
      });
    },
    async handleConfirmMaterialType(value) {
      if (value === "商砼") {
        const vehicleData = await this.getVehicleInfo(
          this.form.data.plateNumber
        );
        this.form.data.tareWeight = vehicleData.tareWeight || 0;
      }

      this.form.data.materialType = value;
      this.form.data.materialName = "";
      this.form.showMaterialTypePicker = false;
    },
    handleConfirmMaterial(value) {
      this.form.data.materialName = value;
      this.form.showMaterialPicker = false;
    },
    getVehicleInfo(plateNumber) {
      const payload = {
        page: { current: 1, page: 10 },
        where: {
          "eq_vehicle.vehicleNo": plateNumber,
        },
      };
      return getVehicleList(payload).then(({ data: { page } }) => {
        const { records } = page;
        if (Array.isArray(records) && records.length) {
          return records[0];
        }
        return {};
      });
    },
    async submit() {
      const payload = pick(this.form.data, [
        "id",
        "plateNumber",
        "materialType",
        "materialName",
        "supplier",
        "grossWeight",
        "tareWeight",
      ]);

      payload.netWeight =
        Number(payload.grossWeight) - Number(payload.tareWeight);
      payload.deductWeight = +(
        +payload.tareWeight / +payload.grossWeight
      ).toFixed(2);

      this.loading = true;

      await Dialog.confirm({
        title: "确认修改无人过磅记录？",
        message: "流水号：" + payload.id,
        theme: "round-button",
      }).catch(() => {
        showPhoneAlarm(
          true,
          "toast",
          "success",
          2000,
          200,
          "修改无人过磅取消",
          "取消"
        );
        throw "修改无人过磅取消";
      });

      const { data } = await edit(payload).finally(() => {
        this.loading = false;
      });

      if (
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          data.code,
          "修改无人过磅",
          data.msg || data.message || ""
        )
      ) {
        this.$router.push({ path: "/service/history/weigh", query: {} });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding-bottom: 80px;
}

.supplier-edit-wrap {
  position: relative;

  .supplier-autocomplete {
    position: absolute;
    background-color: #fff;
    max-height: 230px;
    overflow-y: auto;
    left: 0;
    right: 0;
    z-index: 100;
    box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.06);

    ::v-deep .van-cell {
      font-size: 14px;
      padding: 12px 18px;
    }
  }
}
</style>
